<div class="dropdown sidebar-dropdown switch-language-dropdown" [ngClass]="{'dropdown-large': !collapsedSidebar, 'dropdown-small': collapsedSidebar}">
  <a class="btn btn-secondary dropdown-toggle" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
    {{ (collapsedSidebar ? shortLang : fullLang) | translate }}
  </a>

  <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
    <li><a class="dropdown-item" (click)="switchLanguage('en', 'languages.english')">{{ (collapsedSidebar ? 'en' : 'languages.english') | translate }}</a></li>
    <li>
      <hr class="dropdown-divider">
    </li>
    <li><a class="dropdown-item" (click)="switchLanguage('fr', 'languages.french')">{{ (collapsedSidebar ? 'fr' : 'languages.french') | translate }}</a></li>
  </ul>
</div>
